import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { DagSourceModel } from "@app/workflow-common/services/DagSourceModel";
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { DelayBlockModel } from "@app/workflow-common/services/models/DelayBlockModel";
var DelayBlockWidgetComponent = /** @class */ (function () {
    function DelayBlockWidgetComponent(formBuilder) {
        this.formBuilder = formBuilder;
        this.isConditional = false;
        this.conditionalColName = '';
        this.close = new EventEmitter();
        this.delayBlockData = {};
        this.showDeleteBtn = false;
        this.inputModel = undefined;
        this.units = ['Minutes', 'Hours', 'Days', 'Months'];
        this.minutesInterval = Array.from(Array(60).keys());
        this.hoursInterval = Array.from(Array(24).keys());
        this.daysInterval = Array.from(Array(31).keys());
        this.monthsInterval = Array.from(Array(13).keys());
        this.isFormSubmitted = false;
    }
    DelayBlockWidgetComponent.prototype.ngOnInit = function () {
        this.delayBlockData = this.dagSourceModel.getBlocksSource().getBlockByKey(this.blockObject.key);
        var blockObject = tslib_1.__assign({}, this.blockObject);
        var modelData = blockObject['model'] ? blockObject['model'] : undefined;
        if (modelData) {
            this.showDeleteBtn = true;
        }
        this.inputModel = new DelayBlockModel(modelData);
        var formGroupConfig = {
            interval: new FormControl(this.inputModel.interval, [Validators.required, this.notAllowed()]),
            type: new FormControl(this.inputModel.type),
            unit: new FormControl(this.inputModel.unit, [Validators.required]),
        };
        if (this.isConditional) {
            formGroupConfig['condition'] = this.formBuilder.group({});
        }
        this.form = this.formBuilder.group(formGroupConfig);
    };
    DelayBlockWidgetComponent.prototype.onChangeUnit = function (event) {
        if ((this.form.get('unit').value == 'Months' && this.form.get('interval').value > 12)
            || (this.form.get('unit').value == 'Days' && this.form.get('interval').value > 30)
            || (this.form.get('unit').value == 'Hours' && this.form.get('interval').value > 23)) {
            this.form.get('interval').setValue(0);
        }
    };
    DelayBlockWidgetComponent.prototype.notAllowed = function () {
        return function (control) {
            var forbidden = control.value == 0;
            return forbidden ? { notAllowed: { value: control.value } } : null;
        };
    };
    DelayBlockWidgetComponent.prototype.save = function () {
        var blockObject = tslib_1.__assign({}, this.blockObject);
        blockObject.model = new DelayBlockModel(this.form.value);
        var condition = this.form.value.condition;
        if (this.isConditional) {
            blockObject['condition'] = condition;
            blockObject['isConditional'] = true;
        }
        console.log('xzxc', blockObject);
        this.close.emit({
            action: 'save_and_close',
            data: blockObject
        });
    };
    DelayBlockWidgetComponent.prototype.closeModal = function () {
        this.close.emit({
            action: 'close',
            data: null
        });
    };
    DelayBlockWidgetComponent.prototype.remove = function () {
        var blockObject = tslib_1.__assign({}, this.blockObject);
        blockObject.model = this.inputModel;
        this.close.emit({
            action: 'remove_block',
            data: blockObject
        });
    };
    return DelayBlockWidgetComponent;
}());
export { DelayBlockWidgetComponent };
